module.exports = __webpack_public_path__ + "img/4.0aaae27c.jpg";